import { SPECIAL_CURRENCY_ID } from './player'
import type { PATHWAY_EVENT_TYPE } from '@/types/shared/player-config'

export enum PATHWAY_EVENT_STEP_COST_TYPE {
  FREE = 'free',
  SPECIAL_CURRENCY = 'specialCurrency',
  STAR = 'star',
}

type StepCostFree = {
  type: PATHWAY_EVENT_STEP_COST_TYPE.FREE
}

type StepCostSpecialCurrency = {
  type: PATHWAY_EVENT_STEP_COST_TYPE.SPECIAL_CURRENCY
  currencyId: SPECIAL_CURRENCY_ID
  amount: number
}

type StepCostUSD = {
  type: PATHWAY_EVENT_STEP_COST_TYPE.STAR
  amount: number
  usdAmount: number
}

export type StepCost = StepCostFree | StepCostSpecialCurrency | StepCostUSD

export type StepReward = {
  spins: number
  goldenCoins: number
  giveawayTickets: number
  dropeeStars: number
  specialCurrencies: Partial<Record<SPECIAL_CURRENCY_ID, number>>
}

export type Step = {
  cost: StepCost
  reward: Partial<StepReward>
}

export type PathwayEventConfig = {
  steps: Record<string, Step>
}

export type PathwayEvent = {
  id: string
  eventName: string
  eventType: PATHWAY_EVENT_TYPE | undefined
  instanceDuration: number
  mainColor: string
  mainIcon: string
  startDate: number
  endDate: number
  config: PathwayEventConfig
}
